import { createContext, useContext } from 'react';

/*
  Carries the actual host that served this request (see server.js's requestHostMiddleware,
  which mirrors the sitemap proxy's Original-Host/Host resolution) from SSR through to
  hydration, so components that need "the host actually serving the page" (e.g. CanonicalTag)
  don't have to fall back to window.location.host and go blank/wrong during server render.
*/
const RequestHostContext = createContext<string | null>(null);

export const RequestHostProvider = RequestHostContext.Provider;

export function useRequestHost(): string | null {
  return useContext(RequestHostContext);
}
